/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit'
import {
  Comunidad,
  PartidoJudicial,
  Provincia,
  OrganoJudicial,
  Colegio
} from 'src/interfaces/Catalog/index'
import {
  setColegiosAction,
  setComunidadAction,
  setComunidadesAction,
  setPartidosJudicialesAction,
  setProvinciaAction,
  setProvinciasAction,
  setOrganosJudicialesAction
} from './actions'

interface State {
  colegios: Colegio[]
  comunidades: Comunidad[]
  provincias: Provincia[]
  partidosJudiciales: PartidoJudicial[]
  organosJudiciales: OrganoJudicial[]
  comunidad: Comunidad | null
  provincia: Provincia | null
}

const initialState: State = {
  colegios: [],
  comunidades: [],
  provincias: [],
  partidosJudiciales: [],
  organosJudiciales: [],
  comunidad: null,
  provincia: null
}

export default createReducer(initialState, {
  [setColegiosAction.type]: (state, action) => {
    state.colegios = action.payload
  },
  [setComunidadAction.type]: (state, action) => {
    state.comunidad = action.payload
  },
  [setComunidadesAction.type]: (state, action) => {
    state.comunidades = action.payload
  },
  [setProvinciaAction.type]: (state, action) => {
    state.provincia = action.payload
  },
  [setProvinciasAction.type]: (state, action) => {
    state.provincias = action.payload
  },
  [setPartidosJudicialesAction.type]: (state, action) => {
    state.partidosJudiciales = action.payload
  },
  [setOrganosJudicialesAction.type]: (state, action) => {
    state.organosJudiciales = action.payload
  }
})
